export var navigationItem;
(function (navigationItem) {
    navigationItem["homepage"] = "homepage";
    navigationItem["logo"] = "logo";
    navigationItem["myaccount"] = "myaccount";
    navigationItem["cart"] = "cart";
})(navigationItem || (navigationItem = {}));
//# sourceMappingURL=navigationItem.js.map